import { render, staticRenderFns } from "./LessorItem.vue?vue&type=template&id=0a7ffff8&"
import script from "./LessorItem.vue?vue&type=script&lang=js&"
export * from "./LessorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports